
import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ApiResource } from '../../resources/api.resource';
import { ApiService } from 'src/app/services/api.service';

declare var $: any;


@Component({
 selector: 'soluciones-davivienda-component',
  templateUrl: './soluciones-davivienda.component.html',
  styleUrls: ['./soluciones-davivienda.component.scss']
})
export class SolucionesDaviviendaComponent implements OnInit {
  @Input('configuration') configuration;
  //  //listar productos contradados


isShow = false;

 public tipoPersona;
 public Motivos: string[] =
    [
      'Suspensión temporal de labores no remuneradas',
      'Afectados directamente con disminución de ingresos', 
      'Fuera del país por restricciones', 
      'Estar en cuarentena',
      'Enfermo con el COVID-19',
      'Familiar con COVID-19 en su hogar',
      'Cierre de empresa', 
      'Trabajador por cuenta propia o profesional con baja considerable en sus ventas o ingresos',
      'Ser odontólogo, artista, atleta, mesero o taxista',
      'Ser una micro y pequeña empresa con baja considerable en sus ventas',
      'Otro'
    ];




 public productoPersona = [
    { label: 'Crédito Personal', selected: false }, 
    { label: 'Crédito Hipotecario', selected: false }, 
    { label: 'Tarjeta de crédito y Extrafinanciamiento', selected: false }, 
    { label: 'Sobregiro', selected: false },
    { label: 'Adelanto de Salario (Salario S.O.S.)', selected: false },
    { label: 'Lineas de credito rotativa (Crediflex)', selected: false }
  ];


    
  public productoEmpresa = [
    { label: 'Crédito Decreciente', selected: false }, 
    { label: 'Capital de trabajo', selected: false }, 
    { label: 'Crédito largo plazo', selected: false }, 
    { label: 'Credinegocios', selected: false },
    { label: 'Tarjeta negocios / Tarjeta empresarial', selected: false }

  ];


  public tipoMotivo;
  public otromotivo;
  public tipoCliente;

  public form_data = {
    nombre:'',
    apellido:'',
    tipoMotivo:'',
    tipoCliente:'',
    dui: '',
    pasaporte:'',
    celular:'',
    whatsapp:'no',
    direccion_domicilio:'',
    lugar_trabajo:'',
    direccion_trabajo:'',
    telefono_ofi:'',
    telefono: '',
    correo: '',
    tiposProductos:'',
    tipoCorreo:'1',
    tipoSolicitud:'1'    //ayuda coid19
  };  

  public form_data_empresa = {
    nombre:'',
    razon:'',
    tipoMotivo:'',
    tipoCliente:'',
    pasaporte:'',
    dui: '',
    nit:'',
    celular:'',
    whatsapp:'no',
    direccion_negocio:'',
    telefono_negocio:'',
    direccion_domicilio:'',
    telefono: '',
    correo: '',
    tiposProductos:'',
    tipoCorreo:'1',
    tipoSolicitud:'1'    //ayuda coid19

  };  



  // Para envio de corro personal


  public form_data_personal = {
    tipoCorreo:'2',
    saludo:'Estimado Cliente, hemos recibido su información acorde al siguiente resumen:',
    nombre:'',
    apellido:'',
    tipoMotivo:'',
    tipoCliente:'',
    dui: '',
    pasaporte:'',
    celular:'',
    whatsapp:'no',
    direccion_domicilio:'',
    lugar_trabajo:'',
    direccion_trabajo:'',
    telefono_ofi:'',
    telefono: '',
    correo: '',
    tiposProductos:'',
    tipoSolicitud:'1', 
    pieCorreo:'Estamos trabajando para brindarle una respuesta en el menor tiempo posible. Una vez procesado su arreglo nos comunicaremos con usted.'
  };  


  public form_data_empresa_personal = {
    tipoCorreo:'2',
    saludo:'Estimado Cliente, hemos recibido su información acorde al siguiente resumen:',
    nombre:'',
    razon:'',
    tipoMotivo:'',
    tipoCliente:'',
    pasaporte:'',
    dui: '',
    nit:'',
    celular:'',    
    whatsapp:'no',
    direccion_negocio:'',
    telefono_negocio:'',
    direccion_domicilio:'',
    telefono: '',
    correo: '',
    tiposProductos:'',
    tipoSolicitud:'1' ,
    pieCorreo:'Estamos trabajando para brindarle una respuesta en el menor tiempo posible. Una vez procesado su arreglo nos comunicaremos con usted.'


  };  
  
  public tipoProdV: string;
  public tipoPersonaV: string;
  public tipoProductoV: string;
  public duiV: string;
  public telefonoV: string;
  public correoV: string;

  public form_solic = {   
    tipoMotivo: '',
    tipoMotivoOtro: '',
    tipoPersona: '',
    tipoProducto: '',
    dui: '',
    telefono: '',
    correo: ''
  }

public indiceTipo;

  public validacionToken = {
    dui: null,
    token: null
  };

 

  public lista;
  listaDocumentosOnbase: any[] = [];

  public mensajeParaValidacionToken = '';

  public activarBotonDeModal = true;
  public activarValDui = true;
  

 checkboxPersona: Array<string> = []; 
 checkboxEmpresa: Array<string> = []; 

 checkboxPersonaWh; 
 checkboxEmpresaWh; 

//  variable para checkbox
 public isChecked;

  constructor(private router: Router, private resource: ApiResource, private globals: ApiService) {

  }



checkPersonas(data:string){
/*
 this.checkboxPersona  = this.checkboxPersona.concat([data]);
  /*if(this.isChecked == true){

  } 
  console.warn(this.checkboxPersona.length );
  console.warn(this.checkboxPersona );
   
  console.warn(this.isChecked ); */

}


checkPersonas2(e){
//this.checkboxEmpresa = this.checkboxEmpresa.concat([data]);
  console.warn(e.target.checked);
  console.warn(e.target.value);

  if(e.target.checked == true){
    //console.log('true--');
    this.checkboxPersona = this.checkboxPersona.concat(e.target.value);

  }else{
    this.removeElement(this.checkboxPersona, e.target.value );
    //console.log('false--');
  
}
 console.log(this.checkboxPersona);
}

checkPersonasWh2(e){
//this.checkboxEmpresa = this.checkboxEmpresa.concat([data]);
  console.warn(e.target.checked);
  console.warn(e.target.value);

  if(e.target.checked == true){
    console.log('si');
    this.checkboxPersonaWh = 'si';
    this.form_data.whatsapp= 'si';
  }else{
    this.checkboxPersonaWh = 'no';
    this.form_data.whatsapp= 'no';
    //console.log('no');
  
}
 console.log(this.checkboxPersona);
}

checkEmpresaWh2(e){
//this.checkboxEmpresa = this.checkboxEmpresa.concat([data]);
  console.warn(e.target.checked);
  console.warn(e.target.value);

  if(e.target.checked == true){
    console.log('si');
    this.checkboxEmpresaWh = 'si';
    this.form_data_empresa.whatsapp= 'si';
  }else{
    this.checkboxEmpresaWh = 'no';
    this.form_data_empresa.whatsapp= 'no';
    console.log('no');
  
}
 //console.log(this.checkboxPersona);
}


 removeElement(array, elem) {
    var index = array.indexOf(elem);
    if (index > -1) {
        array.splice(index, 1);
    }
}


checkEmpresa(data:string){
 //this.checkboxEmpresa = this.checkboxEmpresa.push);
//console.log(dat);
//console.log(this.checkboxEmpresa);

}



checkEmpresa2(e){
 
  if(e.target.checked == true){
    //console.log(e.target.checked);
    this.checkboxEmpresa = this.checkboxEmpresa.concat(e.target.value);

  }else{
    if(e.target.checked == false){
      //console.log(e.target.checked);
      this.removeElement(this.checkboxEmpresa, e.target.value );
  }
}
 console.log(this.checkboxEmpresa);
}



  enviarCorreoElectronico() {
    //se llenan las variables del areglo con las variables de form_data de la primer modal solicitada de datos
    var data; 
  
  
     if (this.form_solic.tipoPersona == "1"){

       if(this.tipoMotivo=='Otro'){
          this.form_data.tipoMotivo=this.otromotivo;
       }else{
          this.form_data.tipoMotivo=this.tipoMotivo;
       }
       this.form_data.tiposProductos=this.checkboxPersona.join(', ');
       this.form_data.tipoCliente=this.tipoCliente;
       this.form_data_empresa.tipoCliente=this.tipoCliente;

       

// enviando a correo personal
        this.form_data_personal.nombre=this.form_data.nombre;
        this.form_data_personal.apellido=this.form_data.apellido;
        this.form_data_personal.celular=this.form_data.celular;
        this.form_data_personal.correo=this.form_data.correo;
        this.form_data_personal.dui=this.form_data.dui;
        this.form_data_personal.pasaporte=this.form_data.pasaporte;
        this.form_data_personal.telefono=this.form_data.telefono;
        this.form_data_personal.tipoMotivo=this.form_data.tipoMotivo;
        this.form_data_personal.tiposProductos=this.form_data.tiposProductos;
        this.form_data_personal.tipoCliente=this.form_data.tipoCliente;
        this.form_data_personal.whatsapp=this.form_data.whatsapp;
        this.form_data_personal.direccion_domicilio=this.form_data.direccion_domicilio;
        this.form_data_personal.lugar_trabajo=this.form_data.lugar_trabajo;
        this.form_data_personal.direccion_trabajo=this.form_data.direccion_trabajo;
        this.form_data_personal.telefono_ofi=this.form_data.telefono_ofi;
        
        data= {
            form_data: this.form_data_personal,
            to: this.form_data_personal.correo,
            form_name: "Solicitud de ayuda COVID-19"

        }

        this.resource.sendEmail(data).subscribe();

// enviando a correo institucinal
        data = {          
        form_data: this.form_data,
        to: 'soluciones@davivienda.com.sv',      
        form_name: "Solicitud de ayuda COVID-19"
        };



      }else{
         
         if(this.tipoMotivo=='Otro'){
          this.form_data_empresa.tipoMotivo=this.otromotivo;
       }else{
          this.form_data_empresa.tipoMotivo=this.tipoMotivo;
       }

       //console.log(this.form_data_empresa.tipoMotivo);
       
        this.form_data_empresa.tipoCliente=this.tipoCliente;

        this.form_data_empresa.tiposProductos=this.checkboxEmpresa.join(', ');

        ///////////mandando correo a la cuenta de empresas
        this.form_data_empresa_personal.nombre=this.form_data_empresa.nombre;
        this.form_data_empresa_personal.razon=this.form_data_empresa.razon;
        this.form_data_empresa_personal.nit=this.form_data_empresa.nit;
        this.form_data_empresa_personal.celular=this.form_data_empresa.celular;
        this.form_data_empresa_personal.correo=this.form_data_empresa.correo;
        this.form_data_empresa_personal.dui=this.form_data_empresa.dui;
        this.form_data_empresa_personal.telefono=this.form_data_empresa.telefono;
        this.form_data_empresa_personal.tipoMotivo=this.form_data_empresa.tipoMotivo;
        this.form_data_empresa_personal.tiposProductos=this.form_data_empresa.tiposProductos; 
        this.form_data_empresa_personal.tipoCliente=this.form_data_empresa.tipoCliente; 
        this.form_data_empresa_personal.pasaporte=this.form_data_empresa.pasaporte; 
        this.form_data_empresa_personal.whatsapp=this.form_data_empresa.whatsapp; 
        this.form_data_empresa_personal.direccion_negocio=this.form_data_empresa.direccion_negocio; 
        this.form_data_empresa_personal.telefono_negocio=this.form_data_empresa.telefono_negocio; 
        this.form_data_empresa_personal.direccion_domicilio=this.form_data_empresa.direccion_domicilio; 

        
        console.log("persnonal:"+this.form_data_empresa_personal.razon);
        console.log("institucional: "+this.form_data_empresa.razon);
        
         data= {
            form_data: this.form_data_empresa_personal,
            to: this.form_data_empresa_personal.correo,
            form_name: "Solicitud de ayuda COVID-19"

        }

        this.resource.sendEmail(data).subscribe();

data = {          
        form_data: this.form_data_empresa,
        to: 'soluciones@davivienda.com.sv,servicioabancaempresa@davivienda.com.sv',
        
        form_name: "Solicitud de ayuda COVID-19"
       };


console.log('empresa:');
         console.log(this.form_data_empresa.tipoCliente);
      console.log(this.form_data_empresa.tipoMotivo);

      }

    

  
    this.resource.sendEmail(data).subscribe(resp => {
      if (resp.response == 'Success.') {
        this.form_data.nombre = null;
        this.form_data.apellido = null;
        this.form_data.dui = null;
        this.form_data.pasaporte = null;
        this.form_data.celular = null;
        this.form_data.telefono= null;
        this.form_data.correo= null;

        this.form_data_empresa.razon= null;
        this.form_data_empresa.nombre= null;
        this.form_data_empresa.dui= null;
        this.form_data_empresa.nit= null;
        this.form_data_empresa.celular= null;
        this.form_data_empresa.telefono= null;
        this.form_data_empresa.correo= null;
        this.form_data_empresa.pasaporte= null;


      }
      else {
        this.form_data.nombre = null;
        this.form_data.apellido = null;
        this.form_data.dui = null;
        this.form_data.pasaporte = null;
        this.form_data.celular = null;
        this.form_data.telefono= null;
        this.form_data.correo= null;

         this.form_data_empresa.razon= null;
        this.form_data_empresa.nombre= null;
        this.form_data_empresa.dui= null;
        this.form_data_empresa.nit= null;
        this.form_data_empresa.celular= null;
        this.form_data_empresa.telefono= null;
        this.form_data_empresa.correo= null;
        this.form_data_empresa.pasaporte= null;
        


      }
    },
      err => {
        this.form_data.nombre = null;
        this.form_data.apellido = null;
        this.form_data.dui = null;
        this.form_data.pasaporte = null;
        this.form_data.celular = null;
        this.form_data.telefono= null;
        this.form_data.correo= null;

         this.form_data_empresa.razon= null;
        this.form_data_empresa.nombre= null;
        this.form_data_empresa.dui= null;
        this.form_data_empresa.nit= null;
        this.form_data_empresa.celular= null;
        this.form_data_empresa.telefono= null;
        this.form_data_empresa.correo= null;
        this.form_data_empresa.pasaporte= null;



      }
    );
  }

  ngOnInit() {
    this.toggleModal();
    //this.checkBoxPersonas();

    //this.toggle_visibility();

  }


toggleDisplay(){
  
     let parrafo = window.document.getElementById('declaracion2') as HTMLDivElement;
      //let checkbox = window.document.getElementById('checkbox') as HTMLInputElement;

      if(parrafo.style.display == 'none'){
        parrafo.style.display='block';
      }
      else if(parrafo.style.display == 'block'){
        parrafo.style.display='none';
      }
}


  toggleModal(isLast = false) {
    let modalForm = $('#documentos');

    if (modalForm.hasClass('active')) {
      $('body').removeClass('overflow-hidden');
    } else {
      $('body').addClass('overflow-hidden');
    }

    modalForm.toggleClass('active');

    if (isLast) {
      this.showModal(1);
    }
  }

  tokenVencido = false;


  public habilitar(value:string)
		{
			if(value=="1")
			{
        console.warn('1')
        // let persona=window.document.getElementsByClassName('personaCh') as HTMLCollectionOf<HTMLDivElement>;
        // persona[0].style.display='block';

			}else if(value=="2"){
			
			}
		}


  reintentar() {
    this.mensajeParaValidacionToken = "";
    $('.page-modal .modal').removeClass('active');
    $('.page-modal .modal-1').addClass('active');
  }

  showModal(id) {

    this.activarBotonDeModal = false;
    this.tokenVencido = false;

    // generar token
    if (id == 2) { // tel, dui, email


        this.tipoCliente=this.form_solic.tipoPersona;

          if(this.form_solic.tipoMotivo != '' && this.form_solic.tipoPersona!= '' ){
             console.log(this.form_solic.tipoMotivo );   

            if(this.form_solic.tipoMotivo=='Otro'){
              console.log('otro-----');
                if (this.form_solic.tipoMotivoOtro!= '')
                {
                  //console.log(this.form_solic.tipoMotivoOtro);
                    this.otromotivo=this.form_solic.tipoMotivoOtro;
                    this.tipoMotivo=this.otromotivo;
                    console.log(this.otromotivo);
                    $('.page-modal .modal').removeClass('active');
                    $('.page-modal .modal-' + id).addClass('active');
                    this.activarBotonDeModal = true;

                }else{
                  //llene los campos
                }
            }else {      
              console.log(this.form_solic.tipoMotivoOtro);
               console.log(this.form_solic.tipoMotivo); 
          
              this.tipoMotivo=this.form_solic.tipoMotivo;

                    $('.page-modal .modal').removeClass('active');
                    $('.page-modal .modal-' + id).addClass('active');
                    this.activarBotonDeModal = true;
            }
        }else{

        }
      //console.log(this.form_solic.tipoPersona);
    }
    //validar token
    if (id == 3) { //token  

      if (this.form_solic.tipoPersona == "1"){
          if(this.checkboxPersona.length >0){
            console.log(this.checkboxPersona.length);
              $('.page-modal .modal').removeClass('active');
              $('.page-modal .modal-' + id).addClass('active');
              this.activarBotonDeModal = true;
          }
      }else{
          if(this.checkboxEmpresa.length >0){
             console.log(this.checkboxEmpresa.length);

              $('.page-modal .modal').removeClass('active');
              $('.page-modal .modal-' + id).addClass('active');
              this.activarBotonDeModal = true;
          }
      }

       
    }


   if (id == 4) {  

      if (this.form_solic.tipoPersona == "1"){
             console.log('numeric data-: '+this.allnumeric(this.form_data.dui));
          if(this.allnumeric(this.form_data.dui)){
              $('.page-modal .modal').removeClass('active');
              $('.page-modal .modal-4').addClass('active');
              this.activarBotonDeModal = true;
              this.activarValDui=true;
          }else{
              this.activarValDui=false;
          }
      }else{
         console.log('numeric data-: '+this.allnumeric(this.form_data_empresa.dui));
          if(this.allnumeric(this.form_data_empresa.dui)){
              $('.page-modal .modal').removeClass('active');
              $('.page-modal .modal-4').addClass('active');
              this.activarBotonDeModal = true;
              this.activarValDui=true;
          }else{
              this.activarValDui=false;
          }
      }


          
          

       
    
    }
  }

 

  cerrarModal() {
    // remuevo las clases
    $('.page-modal .modal').removeClass('active');
    $('.page-modal .modal-1').addClass('active');

    this.form_solic = {   
    tipoMotivo: '',
    tipoMotivoOtro: '',
    tipoPersona: '',
    tipoProducto: '',
    dui: '',
    telefono: '',
    correo: ''
  };
    
  }

  cerrarModalFinal() {
    //$('.page-modal .modal-4').removeClass('active');
    $('.page-modal .modal-3').removeClass('active');
    $('.page-modal .modal-2').removeClass('active');
    $('.page-modal .modal').removeClass('active');
    $('.page-modal .modal-1').addClass('active');
    
  }


  urlServiceDescargarOnbase = `${this.globals.urlServidor}/descargar/`;

  descargar(nameFile: any) {
    // window.open(this.urlServiceDescargarOnbase + nameFile, '_self');//Original
    window.open(this.urlServiceDescargarOnbase + nameFile, '_blank');
  }

  onlyNumbers(event) {
    let keyCode = event['keyCode'] || 0;
    if (keyCode < 48 || keyCode > 57) {
      event.preventDefault();
    }
  }


allnumeric(val: string)
   {
    
    var expR = /^[0-9]{9}$/;
    var Rta = expR.test(val);
    if(Rta == false){
      //manda un mensaje
      
    console.log(val);
    return false;
    }
    else if(Rta == true){
      //que envie el formulario
      
    //console.log(Rta);
    console.log(val);

    return true;
    }
  } 

}
